:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pos-absolute{position:absolute;}
:root ._l-t-space-med104641{left:var(--t-space-medium);}
:root ._t-0px{top:0px;}
:root ._b-0px{bottom:0px;}
:root ._justify-center{justify-content:center;}